import {
  isSubsetOfContext,
  type PermissionGroupName,
  type PermissionGroups,
} from '@studio/core/utils/permission';

import type { Experience } from './types';

export type ExperienceRoleResolver = (experience: Experience) => Set<string>;

export function createExperienceRoleResolver(
  userLegacyRoleNames: readonly string[],
  userLegacyRoleConditions: Partial<Experience> | null | undefined,
  userPermissionGroupNames: readonly PermissionGroupName[],
  permissionGroups: PermissionGroups,
): ExperienceRoleResolver {
  return function resolveExperienceRoles(experience: Experience): Set<string> {
    const resolvedRoleNames = new Set<string>();

    if (isSubsetOfContext(userLegacyRoleConditions, experience)) {
      for (const legacyRoleName of userLegacyRoleNames) {
        resolvedRoleNames.add(legacyRoleName);
      }
    }

    for (const groupName of userPermissionGroupNames) {
      const group = permissionGroups.get(groupName);
      if (group != null) {
        for (const role of group.roles) {
          if (!resolvedRoleNames.has(role.name)) {
            const mergedConditions =
              role.conditions != null
                ? { ...group.conditions, ...role.conditions }
                : group.conditions;

            if (isSubsetOfContext(mergedConditions, experience)) {
              resolvedRoleNames.add(role.name);
            }
          }
        }
      }
    }

    return resolvedRoleNames;
  };
}
